<template>
    <div class="wrapper ">
        <Sidebar />
        <div class="main-panel" id="main-panel">
            <Header />
            <div class="panel-header panel-header-sm">
                <canvas id="bigDashboardChart"></canvas>
            </div>
            <div class="content">
                <Loading v-if="loading === true"/>
                <div id="row">
                    <div class="card">
                        <div class="card-header">
                            <h5 class="card-title">Mediums</h5>
                            <div class="row text-center">
                                <div class="col">
                                    <label class="switch">
                                        <input v-model="addTab" type="checkbox" id="togBtn" @change="resetAlerts()">
                                        <div class="slider round">
                                            <span style="font-size: 15px;" class="off">Edit</span>
                                            <span style="font-size: 15px;" class="on">Add New</span>
                                        </div>
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div class="card-body">
                            <div v-if="addTab == false">
                                <div class="row mb-5">
                                    <div class="col-3">
                                        <select class="form-control custom-dropdown" v-model="selectedMedium" @change="resetAlerts()">
                                            <option disabled selected value="">Pick a Medium</option>
                                            <option v-for="medium in mediums" :key="medium.id" :value="medium">{{ medium.name }}</option>
                                        </select>
                                    </div>
                                </div>
                                <div v-if="selectedMedium.id">
                                    <div class="row mb-4">
                                        <div class="col-4">
                                            <label>Name:</label>
                                            <input v-model="selectedMedium.name" type="text" class="form-control"/>
                                        </div>
                                    </div>
                                    <div v-if="selectedMedium.icon != null" class="row mb-4">
                                        <div class="col-6">
                                            <label>Icon:</label>
                                            <img :src="selectedMedium.icon" />
                                        </div>
                                    </div>

                                    <div class="row mb-4">
                                        <div v-if="selectedMedium.icon_image != null" class="col-6">
                                            <div class="card">
                                                <div class="card-header">
                                                    <p>{{ selectedMedium.icon_image.split('/').pop() }}</p>
                                                </div>
                                                <div class="card-body">
                                                    <img :src="selectedMedium.icon_image"/>
                                                </div>
                                            </div>
                                            
                                        </div>
                                        <div class="col">
                                            <Dropzone name="dropzone" id="dropzone" ref="imageDropzone" 
                                                :options="imageDropzoneOptions" 
                                                :useCustomSlot=true 
                                                v-on:vdropzone-sending="appendFileName" 
                                                @vdropzone-file-added="fileInDropzone=true"
                                                @vdropzone-removed-file="fileInDropzone=false">
                                                <div class="dropzone-custom-content">
                                                    <h5 class="dropzone-custom-title">Click here or drag and drop an image</h5>
                                                    <div class="subtitle dropzone-custom-sub">accepted file types: png, jpg, jpeg</div>
                                                </div>
                                            </Dropzone>
                                            <button class="btn btn-primary" @click="uploadImage">Upload Image</button>
                                            <button v-if="fileInDropzone" class="btn btn-outline-danger ml-4" @click="removeImage">Clear Dropzone</button>
                                        </div>
                                    </div>
                                    <button class="btn btn-primary mt-5" @click="updateMedium()">Update Medium</button>
                                    <button class="btn btn-primary btn-danger mt-5 float-right" @click="deleteMedium()"><i class="text-white fa fa-trash"></i> Delete Medium</button>
                                </div>
                                <Alert v-if="successMessage.length > 0" :message="successMessage" :error="false"/>
                                <Alert v-if="errorMessage.length > 0" :message="errorMessage" :error="true"/>
                            </div>

                            <div v-else>
                                <div class="row mb-4">
                                    <div class="col-4">
                                        <label>* Name:</label>
                                        <input v-model="newMedium.name" type="text" class="form-control"/>
                                    </div>
                                </div>
                                <div v-if="selectedMedium.icon != null" class="row mb-4">
                                    <div class="col-6">
                                        <label>Icon:</label>
                                        <img :src="newMedium.icon" />
                                    </div>
                                </div>

                                <div v-if="allowUploadImage == true" class="row mb-4">
                                    <div class="col">
                                         <Dropzone name="dropzone" id="dropzone" ref="imageDropzone" 
                                                :options="imageDropzoneOptions" 
                                                :useCustomSlot=true 
                                                v-on:vdropzone-sending="appendFileName"
                                                @vdropzone-file-added="fileInDropzone=true"
                                                @vdropzone-removed-file="fileInDropzone=false">
                                                <div class="dropzone-custom-content">
                                                    <h5 class="dropzone-custom-title">Click here or drag and drop an image</h5>
                                                    <div class="subtitle dropzone-custom-sub">accepted file types: png, jpg, jpeg</div>
                                                </div>
                                            </Dropzone>
                                        <button class="btn btn-primary" @click="uploadImage">Upload Image</button>
                                        <button v-if="fileInDropzone" class="btn btn-outline-danger ml-4" @click="removeImage">Clear Dropzone</button>
                                    </div>
                                </div>
                                <Alert v-if="successMessage.length > 0" :message="successMessage" :error="false"/>
                                <Alert v-if="errorMessage.length > 0" :message="errorMessage" :error="true"/>
                                <button class="btn btn-primary mt-5" @click="createNew()">Create Medium</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    </div>
</template>

<script>
import Mediums from '../controllers/medium.controller';

import Dropzone from 'vue2-dropzone';
import 'vue2-dropzone/dist/vue2Dropzone.min.css';

export default {
    name: 'Mediums',
    components: {
        Dropzone
    },
    data: function() {
        return {
            addTab: false,
            loading: false,
            allowUploadImage: false,
            mediums: [],
            selectedMedium: '',
            newMedium: {},
            imageDropzoneOptions: {
                url: (process.env.VUE_APP_API_URL + '/medium/upload/57') || "http://localhost:3001/api/medium/upload/57",
                maxFilesize: 50, // Mb
                maxFiles: 1,
                autoProcessQueue: false,
                acceptedFiles: '.png,.jpg,.jpeg',
                header: {
                    'Authorization': 'Bearer ' + localStorage.getItem('access_token')
                }
            },
            fileInDropzone: false,
            errorMessage: '',
            successMessage: ''
        }
    },
    beforeMount: async function() {
        this.loading = true;
        this.mediums = await Mediums.getAll();
        this.loading = false;
    },
    methods: {
        resetAlerts() {
            this.successMessage = '';
            this.errorMessage = '';
        },

        uploadImage() {
            this.$refs.imageDropzone.processQueue();
        },

        removeImage() {
            this.$refs.imageDropzone.removeAllFiles();
        },

        async createNew() {
            this.loading = true;
            let added = await Mediums.createNew(this.newMedium.name);

            if (added == false) {
                this.errorMessage = 'Something went wrong while creating your medium';
                this.successMessage = '';
            } else if (added.error) {
                this.errorMessage = added.error;
                this.successMessage = '';
            } else {
                this.errorMessage = '';
                this.successMessage = 'Medium created successfully';
                this.allowUploadImage = true;
                this.selectedMedium = added;
                this.addTab = false;
                
                // Refresh the mediums list
                this.mediums = await Mediums.getAll();
            }

            this.loading = false;
        },

        async updateMedium() {
            this.loading = true;

            let updated = await Mediums.update(this.selectedMedium.id, this.selectedMedium.name);

            if (updated == true) {
                this.errorMessage = '';
                this.successMessage = 'Medium updated successfully';
                // Refresh the mediums list
                this.mediums = await Mediums.getAll();
            } else if (updated.error) {
                this.errorMessage = updated.error;
                this.successMessage = '';
            } else {
                this.errorMessage = 'Something went wrong while updating your medium';
                this.successMessage = '';
            }

            this.loading = false;
        },

        async appendFileName(file, xhr, formData) {
            file.upload.filename = Date.now() + file.upload.filename.slice(file.upload.filename.lastIndexOf('.'), file.upload.filename.length);
            let uploaded = await Mediums.uploadImage(this.selectedMedium.id, file.upload.filename, file.dataURL);
            if (uploaded == false) {
                this.errorMessage = "Something went wrong with uploading your image"
            } else if (uploaded.error) {
                this.errorMessage = uploaded.error;
            } else {
                this.successMessage = "Image uploaded successfully";
                this.selectedMedium = uploaded;
                this.$refs.imageDropzone.removeAllFiles();
            }
        },

        async deleteMedium() {
            this.loading = true;
            let deleted = await Mediums.delete(this.selectedMedium.id);

            if (deleted == true) {
                this.errorMessage = '';
                this.successMessage = 'Medium deleted successfully';

                // Refresh the mediums list
                this.mediums = await Mediums.getAll();

                // Remove the medium info from the form 
                this.selectedMedium = '';
            } else if (deleted.error) {
                this.errorMessage = deleted.error;
                this.successMessage = '';
            } else {
                this.errorMessage = 'Something went wrong while deleting your medium';
                this.successMessage = '';
            }

            this.loading = false;
        }
    }
}
</script>